import type { FortuneIconProps } from '@/app_components/icons/constants';

export const Facebook = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      height='20'
      stroke='none'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Facebook icon</title>
      <mask
        height='20'
        id='mask0_279_37835'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='20'
        x='0'
        y='0'
      >
        <rect
          fill='#D9D9D9'
          height='20'
          width='20'
        />
      </mask>
      <g mask='url(#mask0_279_37835)'>
        <path
          d='M17.0703 0H2.92969C1.31439 0 0 1.31439 0 2.92969V17.0703C0 18.6856 1.31439 20 2.92969 20H8.82812V12.9297H6.48438V9.41406H8.82812V7.03125C8.82812 5.09262 10.4051 3.51562 12.3438 3.51562H15.8984V7.03125H12.3438V9.41406H15.8984L15.3125 12.9297H12.3438V20H17.0703C18.6856 20 20 18.6856 20 17.0703V2.92969C20 1.31439 18.6856 0 17.0703 0Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
